// src/app/store/version/version.actions.ts
import { createAction, props } from '@ngrx/store';
import { BackendVersion } from '../../services/version.service';

export const loadBackendVersion = createAction('[Version] Load Backend Version');
export const loadBackendVersionSuccess = createAction(
  '[Version] Load Backend Version Success',
  props<{ version: BackendVersion }>()
);
export const loadBackendVersionFailure = createAction(
  '[Version] Load Backend Version Failure',
  props<{ error: any }>()
);
export const resetBackendVersion = createAction('[Version] Reset Backend Version');
